import { Link } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import { Carousel } from "ui/molecules/Carousel";
import { ArticleCard } from "@thrivetribe/mvf.ui.molecules.article-card";
import { ArticleType } from "types";

interface ArticleCarouselProps {
  articles: ArticleType[] | undefined;
}

const ArticlesCarousel = ({ articles }: ArticleCarouselProps): JSX.Element => {
  if (!articles) {
    return <></>;
  }

  return (
    <div className="article-carousel">
      <Carousel
        heading={"Articles"}
        moreText={"More articles"}
        moreLink={"/articles"}
        specificClass={"article-carousel"}
      >
        {articles?.map((article) => (
          <SwiperSlide key={article.id}>
            <Link to={`/articles/${article.slug}`} key={article.id}>
              <ArticleCard
                title={article.title}
                description={article.introduction}
                imgUrl={article.asset.file.url}
                imgTitle={article.asset.file.fileName}
                onClick={() => {
                  window.scroll(0, 0);
                }}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Carousel>
    </div>
  );
};

export default ArticlesCarousel;
